import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { RacuniClient, TipTransakcije } from '@kodit/core/data-api';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-tip-transakcije-uplata-dropdown',
  templateUrl: './tip-transakcije-uplata-dropdown.component.html',
  styleUrls: ['./tip-transakcije-uplata-dropdown.component.scss']
})
export class TipTransakcijeUplataDropdownComponent implements OnInit, OnDestroy {

  private _subs: Subscription = new Subscription();

  /** Props */
  items: SelectItem[] = [];
  dozvoljeniTipovi: TipTransakcije[] = [TipTransakcije.KURSNA_RAZLIKA, TipTransakcije.KAMATNA_NAKNADA, TipTransakcije.PROVIZIJA_BANKE];

  @Input() formCtrl: AbstractControl;
  @Input() formCtrlId: string;
  @Input() parentCtrl: any = 'body';

  constructor(private _client: RacuniClient) { }

  ngOnInit(): void {
    this._load();
  }

  private _load() {
    this._subs.add(
      this._client.getTipTransakcije().subscribe((res) => {
        this.items = res.data
        .filter(x => this.dozvoljeniTipovi.includes(x.tipTransakcije))
        .map((x) => ({
          value: x.tipTransakcije,
          label: x.tipTransakcijeStr,
          title: x.opis,
        }));
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
